"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHorizontal = void 0;
var react_1 = __importDefault(require("react"));
var card_horizontal_styles_1 = require("./card-horizontal.styles");
var CardHorizontal = function (_a) {
    var cabecalho = _a.cabecalho, conteudo = _a.conteudo, btnAcao = _a.btnAcao;
    return (react_1.default.createElement(card_horizontal_styles_1.CardSectionStyled, null,
        react_1.default.createElement(card_horizontal_styles_1.CardContainerStyled, null,
            react_1.default.createElement(card_horizontal_styles_1.CardHeaderStyled, null, cabecalho),
            react_1.default.createElement(card_horizontal_styles_1.VerticalDividerStyled, null),
            react_1.default.createElement(card_horizontal_styles_1.CardContentStyled, null, conteudo)),
        react_1.default.createElement(card_horizontal_styles_1.CardActionStyled, null, btnAcao)));
};
exports.CardHorizontal = CardHorizontal;
